import React from 'react'

function DataPolicy() {
    return (
        <div className='text-start imprint'>
    <h1>Privacy Policy</h1>
    <p><strong>Last update:</strong> January 2025</p>

    <h2>Scope of application</h2>
    <p>
        This Privacy Policy applies to our operating platform 
        <a href="https://confess-data-tool-eu">https://confess-data-tool-eu</a> 
        and apps offered by RWTH Aachen University. The purpose of the platform is the statistical collection and general evaluation of company data according to the principle of data minimization. The aim of our website is to support (especially smaller) companies with their sustainability reporting based on the EU taxonomy. The data entered or uploaded there will then be evaluated in compliance with data protection regulations by our partners, e.g. by RWTH Aachen University, the University of Prague (CVUT) (at least during the pilot phase) and TÜV Rheinland.
    </p>

    <h2>General information</h2>
    <p>
        The following information will provide you with an easy to navigate overview of what will happen with your personal data when you register and visit this website. The term “personal data” comprises all data that can be used to personally identify you. For detailed information about the subject matter of data protection, please consult our Data Protection Declaration, which we have included beneath this copy.
    </p>

    <h2>How do we protect your data?</h2>
    <p>
        We maintain a combination of reasonable physical, administrative, and technological controls to protect your data from unauthorized access or malicious actions. We take reasonable measures to limit the access members of our consortium have to your personal data to those who need to know this data to perform their assigned functions, changes and updates.
    </p>
    <p>After the purpose has been fulfilled, the data is deleted again.</p>
    <p>
        We may change this Privacy Statement to reflect changes in the law, our data handling practices, or the features of our business. The updated Privacy Statement will be available here.
    </p>

    <h2>Data controller</h2>
    <address>
        Rector of RWTH Aachen University
        Templergraben 55
        52062 Aachen (physical address)
        52056 Aachen (postal address)
        Telephone: +49 241 80 1
        Website: <a href="http://www.rwth-aachen.de/rektorat">www.rwth-aachen.de/rektorat</a>
    </address>

    <h2>Data Processing Entity</h2>
    <address>
        Institute for Sustainability in Civil Engineering (INaB)
        Marzia Traverso
        Mies-van-der-Rohe-Straße 1
        52074 Aachen
        Telephone: +49 241 80 2276 9
        Email: info@inab.rwth-aachen.de, rektorat@rwth-aachen.de<br/>
    </address>
            <div>
    <h2>Content Delivery Networks: jsDelivr CDN</h2>
    <p>
        This site uses a so-called "Content Delivery Network" (CDN) from jsDelivr. 
        A CDN is a service that helps deliver the content of our online offer, particularly large media files such as graphics or scripts, faster using regionally distributed servers connected via the Internet. User data is processed solely for these purposes and to maintain the security and functionality of the CDN.
    </p>
    <p>
        A CDN (Content Delivery Network) is a network of globally distributed servers that provide replicated content. This means that when a user from the USA accesses a website, they receive the content from the nearest server available, while a user from Germany receives it from Frankfurt, for example.
    </p>
    <p>
        jsDelivr retains personal data processed on our behalf for as long as necessary to provide the services offered, comply with legal obligations, resolve disputes, and enforce agreements. For this purpose, your browser must connect to the CDN servers; therefore, the CDN becomes aware that our website has been accessed via your IP address.
    </p>
    <p>
        The use of jsDelivr is based on our legitimate interests in ensuring secure and efficient provision, analysis, and optimization of our online offer in accordance with Art. 6 para. 1 lit. f GDPR.
    </p>
    <p>
        Further information can be found in the privacy policy of jsDelivr: 
        <a href="https://www.jsdelivr.com/privacy-policy-jsdelivr-net/">https://www.jsdelivr.com/privacy-policy-jsdelivr-net/</a>.
    </p>

    <h3>JavaScript Usage</h3>
    <p>
        Our website uses JavaScript code from Prospectone Sp. z o.o., ul. Krolweska 65A, 30-081 Krakow, Poland (hereinafter: jsdeliver.net). The JavaScript code "gstatic.com" is a component of Google used to analyze website statistics. If JavaScript is activated in your browser and you have not installed a JavaScript blocker such as "ghostery.com", your web browser may transmit your personal data to jsdeliver.net.
    </p>
    <p>
        The use of cdn.jsdelivr.net ensures technically error-free presentation of our website content and constitutes a legitimate interest pursuant to Art. 6 para. 1 lit. f GDPR.
        To prevent execution of JavaScript code from jsdeliver.net gstatic.com, you can use a JavaScript blocker like "noscript.net" or "ghostery.com". Alternatively, you can deactivate JavaScript execution in your web browser settings.
        Further information can be found in the privacy policy of jsdeliver.net: 
        <a href="https://www.jsdelivr.com/about">https://www.jsdelivr.com/about</a>.
    </p>

</div>

<div>
    <h2>Legal Basis</h2>
    <p>To statistically analyze factual information, we process only necessary personal data based on one or more of the following legal bases:</p>

    <ul>
        <li><strong>To Provide Our Services:</strong> Necessary for you or a legal entity you represent to use our data tool services including self-assessments and customer support.</li>

        <li><strong>Legitimate Interests:</strong> Where we have legitimate interests as described in this Privacy Notice such as improving services and ensuring system security.</li>

        <li><strong>Legal Obligations:</strong> Necessary to comply with relevant laws and legal obligations.</li>

        <li><strong>With Your Consent:</strong> When you consent to our processing your personal information for specified purposes; you may withdraw consent at any time.</li>
    </ul>

   <p>The legal basis for data processing is Art. 6 para. 1 sentence 1 lit. f GDPR. We do not use collected data to draw conclusions about individuals under any circumstances.</p>

</div>

<div>
   <h2>SSL and/or TLS Encryption</h2>
   <p>This website uses either an SSL or TLS encryption program for security reasons and to protect confidential content transmissions such as purchase orders or inquiries submitted by users.</p>

   <p>You can recognize an encrypted connection by checking whether the address line switches from “http://” to “https://” along with seeing a lock icon in your browser's address bar.</p>

   <p>If SSL or TLS encryption is activated, data transmitted cannot be read by third parties.</p>

</div>
            <div>
    <h2>Your Rights</h2>

    <h3>Right to Object to Data Collection (Art. 21 GDPR)</h3>
    <p>
        In the event that data are processed on the basis of art. 6(1)(e) or (f) GDPR, you have the right to object at any time to the processing of your personal data based on grounds arising from your unique situation. This also applies to any profiling based on these provisions.
    </p>
    <p>
        To determine the legal basis for any processing of data, please consult this data protection declaration. If you log an objection, we will no longer process your affected personal data unless we can present compelling grounds for processing that outweigh your interests, rights, and freedoms or if the purpose of processing is claiming, exercising, or defending legal entitlements (objection pursuant to Art. 21(1) GDPR).
    </p>
    <p>
        If your personal data is being processed for direct advertising purposes, you have the right to object at any time to such processing and related profiling (objection pursuant to Art. 21(2) GDPR).
    </p>

    <h3>Right to Log a Complaint with Competent Supervisory Agency</h3>
    <p>
        In case of violations of the GDPR, data subjects are entitled to log a complaint with a supervisory agency in their member state where they usually maintain their domicile or place of work or where the alleged violation occurred. The right to log a complaint is effective regardless of any other administrative or court proceedings available as legal recourse.
    </p>
    <address>
        Berliner Beauftragte für Datenschutz und Informationsfreiheit<br />
        Alt-Moabit 59-61<br />
        10555 Berlin<br />
        Email: <a href="mailto:mailbox@datenschutz-berlin.de">mailbox@datenschutz-berlin.de</a><br />
    </address>

    <h3>Right to Data Portability</h3>
    <p>You have the right to receive your personal data that we process automatically based on your consent or in fulfillment of a contract in a common, machine-readable format. Direct transfer of the data to another controller will be done only if technically feasible.</p>

    <h3>Information about Rectification and Eradication of Data</h3>
    <p>Within applicable statutory provisions, you have the right to demand information about your archived personal data, including their source and recipients as well as the purpose of processing at any time. You may also request rectification or eradication of your data.</p>

    <h3>Right to Demand Processing Restrictions</h3>
    <p>You have the right to demand restrictions on processing your personal data under certain conditions:</p>
    
   <ul>
       <li>If you dispute the correctness of your archived data while verification is ongoing.</li>
       <li>If processing was conducted unlawfully but you prefer restriction over eradication.</li>
       <li>If we no longer need your personal data but you require it for legal entitlements.</li>
       <li>If you have raised an objection pursuant to Art. 21(1) GDPR; rights must be weighed against each other until determined whose interests prevail.</li>
   </ul>

   <p>If you restrict processing, those data may only be processed subject to your consent or for legal claims/defense/protection reasons as stated by EU law.</p>

   <p>If you wish to exercise any rights mentioned above, please contact us at 
   <a href="mailto:rektorat@rwth-aachen.de">rektorat@rwth-aachen.de</a>.</p>

</div>

<div class="data-protection-officer">
   <h2>Data Protection Officer</h2>
   <address>
       Contact details:<br />
       Data Protection Office<br />
       RWTH Aachen University<br />
       Templergraben 83<br />
       52062 Aachen (physical address)<br />
       52056 Aachen (postal address)<br />
       Germany<br />
       Telephone: +49 241 80 94114<br />
       Email: 
       <a href="mailto:dsb@rwth-aachen.de">dsb@rwth-aachen.de</a><br />
       Website: 
       <a href="http://www.rwth-aachen.de/datenschutz">www.rwth-aachen.de/datenschutz</a><br />
   </address>

</div>
            Hier ist der formatierte HTML-Code, um den Inhalt klarer und strukturierter darzustellen:
html

<div>
    <h2>Right to Log a Complaint with the Competent Supervisory Agency</h2>
    <p>
        In the event of violations of the GDPR, data subjects are entitled to log a complaint with a supervisory agency, particularly in the member state where they usually maintain their domicile, place of work, or where the alleged violation occurred. The right to log a complaint is effective regardless of any other administrative or court proceedings available as legal recourse.
    </p>

    <address>
        Bundesbeauftragter für den Datenschutz und die Informationsfreiheit (BfDI)<br />
        Graurheindorfer Straße 153<br />
        53117 Bonn, Germany<br />
        Email: <a href="mailto:poststelle@bfdi.bund.de">poststelle@bfdi.bund.de</a><br />
        Website: <a href="http://www.bfdi.bund.de">www.bfdi.bund.de</a>
    </address>
</div>

<div>
    <h2>Pictures, Texts, Videos &; Logos - Licenses &; Labels</h2>
    <p>Do not use copyrighted material without first making appropriate agreements with the author or the respective rights holder.</p>
</div>

<div>
    <h3>Protected Under Copyright Law Are:</h3>
    <ul>
        <li>Photos (always)</li>
        <li>Videos (always)</li>
        <li>Texts (with appropriate level of copyright)</li>
        <li>Graphics and web design (not always protected by copyright)</li>
        <li>The use of logos should be approved by the owner.</li>
    </ul>
</div>

<div>
    <h2>Liability for Contents</h2>
    <p>Please consider both your own and third-party content:</p>

    <ul><strong>Your Own Content:</strong><br/>
        <li>The operator of the website is liable for its own content on the website in accordance with general law; there are no special provisions regarding liability for own content.</li></ul>

   <ul><strong>Third-party Content:</strong><br/>
       <li>The site operator is only responsible for third-party content if they:
           <ul><strong>- Have knowledge of illegal content;</strong></ul><strong>- Have not immediately blocked or deleted such content;</strong></li></ul>

   <ul><strong>Monitoring Obligation:</strong><br/>
       <li>No obligation exists under Section 7(1) DDG and Article 8 DSA expressly stating monitoring third-party user-generated content; however case law may impose duties like checking comments/blogs/forums due diligence might apply here depending on circumstances surrounding "Stoererhaftung" breaches.</li></ul>
</div>
</div>
    )
}

export default DataPolicy